import PropTypes from 'prop-types';
import React from 'react';

/* =========================================================================  */
/* Component(s) */
/* =========================================================================  */

const SkipLink = props => {
    return (
        <a
            className='link-reset skip-link type-style-5'
            href={props.href}>
            {props.children}
        </a>
    );
};

/* =========================================================================  */
/* Typing and export(s) */
/* =========================================================================  */

const propTypes = {
    href: PropTypes.string.isRequired,
    children: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element
    ]).isRequired
};

SkipLink.propTypes = propTypes;

export { SkipLink };

export default SkipLink;
